import {createRouter, createWebHistory} from "vue-router";
import OrderPage from "@/components/OrdersPage.vue";
import LoginPage from "@/components/LoginPage.vue";
import MobileOrders from "@/components/MobileOrders.vue";
import DeskopMenu from "@/components/DeskopMenu.vue";
// import OrderToDay from "@/components/PaidOrdersPage.vue";
import HomePage from "@/components/HomePage.vue";
import MenuPage from "@/components/MenuUser.vue";

import Cookies from "js-cookie";


const routes = [
    {path: "/mobile-menu", component: MobileOrders, meta: {requiresAuth: true}},
    {path: "/tab-menu", component: DeskopMenu, meta: {requiresAuth: true}},
    {path: "/kitchen", component: OrderPage, meta: {requiresAuth: true}},
    {
        path: "/history",
        component: () => import('../components/history/HistoryLayout.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '', // default
                redirect: '/history/today'
            },
            {
                path: 'today',
                name: 'OrderToDay',
                component: () => import('../components/history/PaidOrdersPage.vue')
            },
            {
                path: 'monthly',
                name: 'MonthlyRevenue',
                component: () => import('../components/history/RevenueMonth.vue')
            },
        ]
    },
    {path: "/home", component: HomePage}, // ✅ không requiresAuth
    {path: "/menu", component: MenuPage}, // ✅ không requiresAuth
    {path: "/login", component: LoginPage}, // ❌ không requiresAuth
    {path: "/", redirect: "/menu"}         // route mặc định
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = Cookies.get("token");

    if (to.meta.requiresAuth && !isAuthenticated) {
        next("/login"); // ✅ redirect về login
    } else {
        next();
    }
});

export default router;
